import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import CommentButton from '../../buttons/CommentButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import MoreButton from '../../buttons/MoreButton';
import s from './SimpleActionBar.scss';
var SimpleActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var _b = useDeviationAttributes(deviation, isOwner), hasMoreActions = _b.hasMoreActions, isCommentable = _b.isCommentable, isEditable = _b.isEditable, isDeletable = _b.isDeletable;
    return (React.createElement(ActionBarStrip, null,
        React.createElement(CentralColumn, { className: s['root'] },
            React.createElement("div", { className: s['left-side'] }, isCommentable && (React.createElement("span", { className: s['icon'] },
                React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner })))),
            React.createElement("div", { className: s['right-side'] },
                isDeletable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(DeleteButton, { deviation: deviation }))),
                isEditable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(EditButton, { deviation: deviation }))),
                hasMoreActions && (React.createElement("span", { className: s['icon'] },
                    React.createElement(MoreButton, { deviation: deviation })))))));
};
SimpleActionBar.displayName = 'SimpleActionBar';
export default SimpleActionBar;
//# sourceMappingURL=SimpleActionBar.js.map